module.exports = __webpack_public_path__ + "static/img/erweima-logo2.10d67d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/erweima-logo2.jpg
// module id = eMMv
// module chunks = 14